/* Keep the three independent RZM3 woodworking purchase selectors in step. */
(() => {
  const maskSelector = '[id*="__featured_product_FBMBKb"] product-info';
  const extraSelector = '[id*="__woodworking_filter_purchase_product"] product-info';
  const refillSelector = '.rzm3-refill-subscription';
  const spanish = document.documentElement.lang.toLowerCase().startsWith('es');
  const copy = spanish ? {
    matched: 'Filtros de la misma talla que tu máscara RZM3: ',
    mismatch: 'Estos filtros no coinciden con la talla de tu máscara RZM3 (',
    closing: '). Si son para otra máscara, confírmalo antes de añadirlos.',
    unavailable: 'Los filtros de la talla elegida para tu máscara no están disponibles. No hemos cambiado tu selección.',
    match: 'Igualar a mi máscara',
    other: 'Son para otra máscara RZM3',
    confirmed: 'Talla diferente confirmada para otra máscara RZM3.',
    choose: 'Elige una talla de máscara RZM3 antes de añadir filtros.',
    blocked: 'Comprueba la talla de los filtros o confirma que son para otra máscara RZM3.'
  } : {
    matched: 'Filters matched to your RZM3 mask size: ',
    mismatch: 'These filters do not match your RZM3 mask size (',
    closing: '). If they are for another mask, confirm before adding them.',
    unavailable: 'Matching filters for your selected mask size are unavailable. We have not changed your selection.',
    match: 'Match my mask',
    other: 'These are for another RZM3',
    confirmed: 'Different size confirmed for another RZM3.',
    choose: 'Choose your RZM3 mask size before adding filters.',
    blocked: 'Match your filter size or confirm these are for another RZM3.'
  };

  const state = {
    extra: { override: false, confirmed: false, unavailable: false },
    refill: { override: false, confirmed: false, unavailable: false }
  };
  let applying = false;

  const canonical = (value) => {
    const text = String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    if (/^xl\b|extra.large|extra.grande/.test(text)) return 'xl';
    if (/^small\b|^pequen/.test(text)) return 'small';
    if (/^medium|^mediano|^mediana/.test(text)) return 'medium';
    return '';
  };
  const sizeLabel = (size) => ({
    small: spanish ? 'pequeña' : 'Small',
    medium: spanish ? 'mediana/grande' : 'Medium/Large',
    xl: 'XL'
  })[size] || size;

  const maskInfo = () => document.querySelector(maskSelector);
  const extraInfo = () => document.querySelector(extraSelector);
  const refill = () => document.querySelector(refillSelector);
  const maskSize = () => canonical(maskInfo()?.querySelector('variant-picker fieldset[data-option-index="option1"] input:checked')?.value);
  const extraPicker = () => extraInfo()?.querySelector('variant-picker');
  const extraSize = () => canonical(extraPicker()?.querySelector('fieldset[data-option-index="option1"] input:checked')?.value);
  const refillSelect = () => refill()?.querySelector('select[name="id"]');
  const refillSize = () => canonical(refillSelect()?.selectedOptions[0]?.textContent);
  const selectedSize = (kind) => kind === 'extra' ? extraSize() : refillSize();
  const container = (kind) => kind === 'extra' ? extraInfo() : refill();

  function availableInput(size) {
    const picker = extraPicker();
    const input = [...(picker?.querySelectorAll('fieldset[data-option-index="option1"] input[type="radio"]') || [])]
      .find((item) => canonical(item.value) === size);
    if (!input || input.disabled || input.classList.contains('disabled')) return null;
    const raw = picker.querySelector('script[data-variants]')?.textContent;
    if (!raw) return null;
    try {
      const variants = JSON.parse(raw);
      return variants.some((variant) => variant.option1 === input.value && variant.available) ? input : null;
    } catch (_) { return null; }
  }

  function availableOption(size) {
    return [...(refillSelect()?.options || [])]
      .find((option) => canonical(option.textContent) === size && !option.disabled) || null;
  }

  function note(kind) {
    const host = container(kind);
    if (!host) return null;
    let element = host.querySelector(`.rzm3-size-sync-note[data-kind="${kind}"]`);
    if (element) return element;
    element = document.createElement('div');
    element.className = 'rzm3-size-sync-note';
    element.dataset.kind = kind;
    element.tabIndex = -1;
    element.setAttribute('role', 'status');
    element.setAttribute('aria-live', 'polite');
    if (kind === 'extra') {
      const picker = extraPicker();
      picker?.insertAdjacentElement('afterend', element);
    } else {
      refillSelect()?.insertAdjacentElement('afterend', element);
    }
    return element;
  }

  function render(kind) {
    const element = note(kind);
    if (!element) return;
    const mask = maskSize();
    const chosen = selectedSize(kind);
    const record = state[kind];
    element.replaceChildren();
    element.classList.toggle('is-warning', !mask || chosen !== mask || record.unavailable);
    const message = document.createElement('span');
    if (!mask) message.textContent = copy.choose;
    else if (chosen === mask && !record.unavailable) message.textContent = copy.matched + sizeLabel(chosen) + '.';
    else if (record.unavailable) message.textContent = copy.unavailable;
    else message.textContent = copy.mismatch + sizeLabel(mask) + copy.closing;
    element.append(message);
    if (mask && chosen !== mask) {
      const matchTarget = kind === 'extra' ? availableInput(mask) : availableOption(mask);
      if (matchTarget) {
        const matchButton = document.createElement('button');
        matchButton.type = 'button';
        matchButton.textContent = copy.match;
        matchButton.addEventListener('click', () => {
          record.override = false;
          record.confirmed = false;
          syncOne(kind, true);
        });
        element.append(matchButton);
      }
      const otherButton = document.createElement('button');
      otherButton.type = 'button';
      otherButton.textContent = record.confirmed ? copy.confirmed : copy.other;
      otherButton.disabled = record.confirmed;
      otherButton.addEventListener('click', () => {
        record.override = true;
        record.confirmed = true;
        render(kind);
      });
      element.append(otherButton);
    }
  }

  function syncOne(kind, force = false) {
    const mask = maskSize();
    const record = state[kind];
    if (!mask) { render(kind); return; }
    if (record.override && selectedSize(kind) === mask) {
      record.override = false;
      record.confirmed = false;
    }
    if (record.override && !force) { render(kind); return; }
    const current = selectedSize(kind);
    if (current === mask) {
      record.unavailable = false;
      render(kind);
      return;
    }
    const target = kind === 'extra' ? availableInput(mask) : availableOption(mask);
    record.unavailable = !target;
    if (target) {
      applying = true;
      try {
        if (kind === 'extra') target.click();
        else {
          refillSelect().value = target.value;
          refillSelect().dispatchEvent(new Event('change', { bubbles: true }));
        }
      } finally { applying = false; }
    }
    render(kind);
  }

  function syncAll() {
    syncOne('extra');
    syncOne('refill');
  }

  function handleChange(event) {
    if (applying) return;
    const target = event.target;
    if (target.closest?.(maskSelector) && target.matches('fieldset[data-option-index="option1"] input')) {
      setTimeout(syncAll, 0);
      return;
    }
    let kind = null;
    if (target.closest?.(extraSelector) && target.matches('fieldset[data-option-index="option1"] input')) kind = 'extra';
    if (target === refillSelect()) kind = 'refill';
    if (!kind) return;
    const record = state[kind];
    record.override = selectedSize(kind) !== maskSize();
    record.confirmed = false;
    record.unavailable = false;
    setTimeout(() => render(kind), 0);
  }

  function guardSubmit(event) {
    const form = event.target;
    const kind = form.closest?.(extraSelector) ? 'extra' : form.closest?.(refillSelector) ? 'refill' : null;
    if (!kind) return;
    const mask = maskSize();
    const chosen = selectedSize(kind);
    if (mask && chosen === mask) return;
    if (mask && chosen && state[kind].confirmed) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    render(kind);
    const element = note(kind);
    if (element) {
      element.setAttribute('role', 'alert');
      element.scrollIntoView({ block: 'center', behavior: 'smooth' });
      element.focus({ preventScroll: true });
    }
  }

  function init() {
    if (!maskInfo() || !extraInfo() || !refill()) return;
    document.addEventListener('change', handleChange, true);
    document.addEventListener('submit', guardSubmit, true);
    syncAll();
    const observer = new MutationObserver((mutations) => {
      if (!applying && mutations.some((mutation) => !mutation.target.closest?.('.rzm3-size-sync-note'))) {
        clearTimeout(observer.timer);
        observer.timer = setTimeout(() => {
          render('extra');
          render('refill');
        }, 80);
      }
    });
    observer.observe(extraInfo(), { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
